import { defaultPolygonProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/polygon/default-constants';

export const QUICK_SWAP_CONTRACT_ADDRESS = '0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff';

export const QUICK_SWAP_PROVIDER_CONFIGURATION = defaultPolygonProviderConfiguration;
